import { useEffect } from "react";

import { FILTER } from "@/constants";
import { useEpisodes } from "@/contexts/EpisodesContext";
import { useMentionCards } from "@/contexts/MentionCardsContext";
import useFilterParams from "@/hooks/useFilterParams";
import { cx } from "@/utils";
import Pagination from "@components/Pagination";

import styles from "./MentionPagination.module.css";

const MentionPagination = ({
  className,
  v4 = false,
  disabled,
}: {
  className?: string;
  v4?: boolean;
  disabled?: boolean;
}) => {
  const legacyEpisodesResult = useEpisodes();
  const mentionCardsResult = useMentionCards();

  const meta = v4 ? mentionCardsResult.meta : legacyEpisodesResult.meta;

  const [{ [FILTER.PAGE]: page = 1 }, setFilters] = useFilterParams();

  const setNewPage = ({ newPage }: { newPage: number }) => {
    setFilters({
      [FILTER.PAGE]: newPage,
    });
  };

  const goToPreviousPage = () => {
    const newPage =
      page > 2 ? (typeof page === "string" ? parseInt(page) : page) - 1 : 1;
    setNewPage({
      newPage,
    });
  };

  const goToNextPage = () => {
    if (!meta) return;

    const newPage =
      page < meta.page_count
        ? (typeof page === "string" ? parseInt(page) : page) + 1
        : meta.page_count;

    setNewPage({
      newPage,
    });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  return (
    <Pagination
      disabled={disabled}
      className={cx(styles.root, className)}
      showRest={!v4}
      max={meta?.page_count}
      next={goToNextPage}
      previous={goToPreviousPage}
    />
  );
};

export default MentionPagination;
